import Carousel from '~/themes/base/components/utils/Carousel'

export default {
  extends: Carousel,
}
